import http from 'utils/axiosUtils';
import LocalAuth from '@shamrock-core/common/authentication/local-authentication';

const Config = require('Config');
const { featureServiceUrl } = Config;

export const getFeatures = async () =>
  http.get<string[], unknown>(`${featureServiceUrl}/active?email=${encodeURIComponent((await LocalAuth.getEmail()) as any)}`)();
